import React, { Component} from 'react'
import axios from 'axios';
import TableList from "./TableList";
import { trackPromise } from 'react-promise-tracker';
const api_key = process.env.NODE_ENV === 'production' && process.env.REACT_APP_ENV === 'servcomp-hml' ? process.env.REACT_APP_CONSULTADANFE_HOM : process.env.REACT_APP_CONSULTADANFE_PROD ;
const api_pedido = process.env.NODE_ENV === 'production' && process.env.REACT_APP_ENV === 'servcomp-hml' ? process.env.REACT_APP_PEDIDO_HOM : process.env.REACT_APP_PEDIDO_PROD ;
const api_itens = process.env.NODE_ENV === 'production' && process.env.REACT_APP_ENV === 'servcomp-hml' ?  process.env.REACT_APP_ITENSDANFE_HOM : process.env.REACT_APP_ITENSDANFE_PROD ;
const api_pedido_uni = process.env.NODE_ENV === 'production' && process.env.REACT_APP_ENV === 'servcomp-hml' ? process.env.REACT_APP_PEDIDOUNI_HOM : process.env.REACT_APP_PEDIDOUNI_PROD;


// const axiosConfigGet = {
//   headers: {
//       'Content-Type': 'application/json',
//      // 'Access-Control-Allow-Credentials': 'true',
// /*             'Access-Control-Allow-Methods' : 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
//       'Access-Control-Allow-Headers':  'Access-Control-Allow-Headers,Access-Control-Allow-Origin, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers',
//       'Access-Control-Allow-Origin': '*',*/
//       'Authorization': process.env.REACT_APP_GET_TOKEN
//   }
// };


//const api_proxy = process.env.REACT_APP_PROXY;

//const api_proxyh = process.env.REACT_APP_PROXYH;
//const api_pedidocerto = process.env.NODE_ENV === 'production' && process.env.REACT_APP_ENV === 'servcomp-hml' ? process.env.REACT_APP_PROXYH : process.env.REACT_APP_PROXYH;

//const api_pedido_teste = process.env.REACT_APP_ENV_TEST;
//console.log(api_pedido);
function UserException(message) {
  this.message = message;
  this.name = "UserException";
}

class FormsAndInputs extends Component {
  constructor(props){
    super(props)
    this.state ={
      rows: [],
      name: '',
      loja: '',
      loading: false,
      len: 0,
      limit: 5,
      pages: 0
    }

    this.handleApi = this.handleApi.bind(this);


  }
 

  handleSubmit = (event) => {
    event.preventDefault()
    const data = this.state.name
    const codigo_loja = this.state.loja
    console.log(codigo_loja);
    console.log(data);
    if (this.state.loja !== '' && this.state.name === '') {
      console.log('porloja')
    //  this.setState({ loading: true},() => {
      trackPromise(
        axios.get(api_key+'/danfebyloja/'+codigo_loja).then(response => {
          this.setState({
            rows: response.data,
            loading: false,
            len: response.data.length
          });
          const arrayPages = [];
          const totalPages = Math.ceil(response.data.length / this.state.limit);
          
          for (let i = 1; i < totalPages; i++) {
            arrayPages.push(i);
          }
          this.setState({
            pages: arrayPages
          });
          
          }).catch( erro => {
              alert(erro)
          }))
  //    })
/*         useEffect(()=>{
          fetch(api_key+'/danfebyloja/'+codigo_loja)
          .then(response=>response.json())
          .then(response=>{
            const {body} = response})
            console.log(body)
          },[])
 */
        
    };

    if (this.state.name !== '' && this.state.loja  === '') {
      console.log(this.state.loja)
      console.log('porDANFE')
      trackPromise(
      axios.get(api_key+'/danfe/'+data).then(response => {
        this.setState({
          rows: response.data
        });
        console.log(this.state.rows);
        }).catch( erro => {
            alert("Dados Invalidos [DANFE]")
        }))
    };

    if (this.state.name !== '' && this.state.loja  !== '') {
      console.log('Loja e Danfe')
      trackPromise(
      axios.get(api_key+'/lojadanfe/'+codigo_loja+'/'+data).then(response => {
        this.setState({
          rows: response.data,
          loading: false,
          len: response.data.length
        });

        const arrayPages = [];
        const totalPages = Math.ceil(response.data.length / this.state.limit);
        
        for (let i = 1; i < totalPages; i++) {
          arrayPages.push(i);
        }
        this.setState({
          pages: arrayPages
        });
        console.log(this.state.rows);
        }).catch( erro => {
            alert("Dados Invalidos [DANFE/LOJA]")
        }))
    }

  }

  handleInputChange = (event) => {
    event.preventDefault()
    this.setState({[event.target.name]: event.target.value,
    
    })
  }

  handleInputLoja = (event) => {
    event.preventDefault()
    this.setState({[event.target.name]: event.target.value,
    
    })
  }

  handleApi (itens) {
      console.log("Api Call clicked", itens.id);   
      console.log("API ITens", api_itens); 
      
      if (itens.pedido !== 0) {
        alert("Pedido Já Criado!")
        throw new UserException("Erro");
      }
      const axiosConfig = {
        headers: {
            'Content-Type': 'application/json',
           // 'Access-Control-Allow-Credentials': 'true',
/*             'Access-Control-Allow-Methods' : 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
            'Access-Control-Allow-Headers':  'Access-Control-Allow-Headers,Access-Control-Allow-Origin, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers',
            'Access-Control-Allow-Origin': '*',*/
            'Authorization': process.env.REACT_APP_TOKEN
        }
      };
     // console.log(axiosConfig);
     // axios.use(cors());
      axios.get(api_itens+'/'+itens.codigo_loja+'/'+itens.numero_danfe+'/'+itens.serie).then(res => {
       
        const json = JSON.stringify(res.data);
        const array = JSON.parse(json);
              
        const pedido4=  {companyNumber:itens.companynumber,
          orderNumber:null,
          originSystem:itens.originsystem,
          status:"NEW", 
          storeNumber: itens.codigo_loja,
          totalValue:itens.valor_total,
          customer:{
          customerId: itens.cod_cnpj_cpf,
          customerType: itens.customertype,
          document: itens.cod_cnpj_cpf,
          documentType:itens.documenttype,
          email:itens.email,
          name: itens.des_nome,
          address:{
              addressComplement:"",
              addressName:itens.des_endereco,
              addressNumber:itens.addressNumber,
              city:itens.des_municipio,
              cityCode:null,
              country:"BR",
              neighborhood:itens.des_bairro,
              phone:itens.fone,
              state:itens.uf_cliente,
              zipCode:itens.cod_cep
          }
          },
          fiscalCustomerId:null,
          operatorCode:itens.operatorcode,
          additionalInformations:[  
            {  
               header:"Num. DANFE:",
               textLines:[itens.numero_danfe]
            } ],
          fiscalItems:array,
          nonFiscalItems:[
      
          ],
          discounts:[
      
          ]};     
          


        
          axios.post(api_pedido, pedido4, axiosConfig ).then(response => {
                 const geraPedUnicom =  {codigo_loja:itens.codigo_loja,
                  numero_nf:itens.numero_danfe,
                  serie_nf:itens.serie,
                  cpf_cnpj:itens.cod_cnpj_cpf,
                  pedido:response.data.orderNumber}; 

                  console.log (geraPedUnicom);

                axios.post(api_pedido_uni, geraPedUnicom)
                .then(res => {
                  alert("Pedido "+res.data.pedido+ " Gerado com sucesso");
                  //const data = this.state.name
                  //const loja = this.state.loja
                  if (this.state.name === '') {
                    trackPromise(
                    axios.get(api_key+'/danfebyloja/'+itens.codigo_loja).then(resposta => {
                      //console.log(resposta.data);
                    this.setState({
                      rows: resposta.data,
                      loading: false,
                      len: resposta.data.length
                    });
            
                    const arrayPages = [];
                    const totalPages = Math.ceil(resposta.data.length / this.state.limit);
                    
                    for (let i = 1; i < totalPages; i++) {
                      arrayPages.push(i);
                    }
                    this.setState({
                      pages: arrayPages
                    });
                   // console.log(this.state.rows);
                    this.handleSubmit = this.handleSubmit.bind(this);
                    }).catch( erro => {
                        alert(erro)
                    }))
                } else {
                  trackPromise(
                  axios.get(api_key+'/lojadanfe/'+itens.codigo_loja+'/'+itens.numero_danfe).then(resp => {
                    console.log(resp.data);
                    this.setState({
                      rows: resp.data,
                      loading: false,
                      len: resp.data.length
                    });
            
                    const arrayPages = [];
                    const totalPages = Math.ceil(resp.data.length / this.state.limit);
                    
                    for (let i = 1; i < totalPages; i++) {
                      arrayPages.push(i);
                    }
                    this.setState({
                      pages: arrayPages
                    });
                    console.log(this.state.rows);
                    }).catch( erro => {
                        alert("Dados Invalidos")
                    }))
                }
                  
                }).catch(error => {
                 
                  console.log(error.response);
                  alert(error.response.data.message);
                })                
          })
          .catch(error => {
            console.log(error.response.status);
          //    console.log(error.response);
              alert("Erro ao Integrar o pedido "+ error.response.data.message);
          });




      });



   };




  render() {
    
    return (
      <div>
        <form onSubmit={this.handleSubmit}>
          <div>
          
          <p><label>Número da Loja:</label><input type= 'text' placeholder='Digite o Número da Loja' name='loja' onChange={this.handleInputLoja} required /></p>
          <p><label>Num. NF DANFE:</label><input type= 'text' placeholder='Digite o Num. NF DANFE' name='name' onChange={this.handleInputChange} /></p>
          </div>
         <p> <button type="submit" className="btn btn-outline-dark btn-lg" data-toggle="tooltip" title="Busca DANFE's">Buscar</button> </p>
        </form>
        <div className="load"> <i className="fa fa-cog fa-spin fa-5x fa-fw"></i><span className="sr-only">Loading...</span> </div>
         <TableList rows={this.state.rows} 
            handleApi={this.handleApi}
            total={this.state.len}
            pages={this.state.pages}/>
        

      </div>
    )
  }


}
export default FormsAndInputs